<template>
    <div class="no-disturb">
        <van-nav-bar title="上课免打扰" :fixed="true" style="margin-bottom:15px;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <img class="disturb-img" src="@/assets/images/no-disturb.png" background-size="cover"/>
        <p class="disturb-title">提示：上课免打扰时间段内，设备会拒接所有电话；</p>
        <div class="disturb-switch">
            <p>开启上课免打扰</p>
            <van-switch class="switch-flex" :disabled="timeList.length<=0" v-model="checked" @change="onChange"  size="22px" />
        </div>
        <div v-if="timeList.length>0" class="disturb-content">
            <div v-for="(item,index) in timeList" :key="index" class="disturb-option">
                <div class="option-top">
                <p>免打扰时段</p>
                <img class="option-img" src="@/assets/images/disturb-update.png" @click="addOption(item,index)" background-size="cover"/>
                </div>
                <div class="option-bottom">
                <p class="b-date">{{item.time}}</p>
                <p class="b-week">{{item.day}}</p>
                </div>
            </div>
        </div>
        <div v-else class="no-data">
            <p>暂未添加上课免打扰时段</p>
        </div>
        <div class="btn-box">
            <van-button round type="info" @click="addOption(false)">添加免打扰时段</van-button>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            checked:false,//开关状态
            timeList:[],//免打扰时段
        };
    },

    created() {
        this.getNotDisturb()
    },
    mounted() {
        // document.getElementsByTagName("body")[0].className = "color-body";
    },
    methods: {
        /**
        * 返回上一级
        */
        backPage() {
            this.$router.back(-1);
        },
        onChange(e) {
            console.log(e,555)
        // 需要手动对 checked 状态进行更新
        let data = {
            ver:1,
            method:'setAttendClassDoNotDisturbSwitch',
            stealthStatus: e?'1':'0'
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.$toast({
                    message: "状态修改成功",
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/correct.png'),
                });
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        },
        /**
         *获取上课隐身反显内容
        */
        getNotDisturb(){
        let data = {
            ver:1,
            method:'getAttendClassDoNotDisturbList'
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.checked = res.data.stealthState==="1"?true:false
                this.timeList = res.data.timeList
                this.$store.commit('set_noDisturbList', JSON.stringify(res.data));
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        },
        /**
         * 添加免打扰时段
         */
        addOption(data,index){
        if(data){
            data.stealthStatus = this.checked
            data.index = index
            data.bool = true
            data = JSON.stringify(data)
        }else{
            data = {
            stealthStatus:this.checked,
            bool:false
            }
            data = JSON.stringify(data)
        }
        this.$router.push({ name: 'timeBucket', query: { timeData: data } });
        },
    },

    watch: {

    },
    beforeDestroy() {
        document.body.removeAttribute("class", "color-body");
    },
};
</script>

<style lang="scss" scoped>
.no-disturb{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 40px 0;
}
.disturb-img{
  margin-top: 25px;
  width: 670px;
  height: 220px;
}
.disturb-title{
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin: 30px 0;
}
.no-data{
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  margin-bottom: 70px;
}
.disturb-content{
  margin-bottom: 180px;
}
.disturb-switch{
  width: 100%;
  height: 100px;
  padding: 0 32px;
  background: #fff;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.disturb-switch>p{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #111111;
}
.disturb-option{
  width: 100%;
  padding: 32px;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.disturb-option .option-img{
  width: 30px;
  height: 30px;
}
.disturb-option .option-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 23px;
}
.disturb-option .option-top>p{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #111111;
}
.disturb-option .option-bottom{
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}
.disturb-option .option-bottom .b-date{
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #111111;
  margin-bottom: 16px;
}
.disturb-option .option-bottom .b-week{
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style lang="scss">
.no-disturb .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
.no-disturb .switch-flex{
  display: flex;
  align-items: center;
}
.van-switch--on{
  background-color: #02ADA9 !important;
}
.no-disturb{
    .van-nav-bar{
        background-color: #F8F8F8;
        width: 100%;
    }
}
</style>